module.exports = __webpack_public_path__ + "static/img/13.7c74bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/13.jpg
// module id = MT/h
// module chunks = 1